import { TextField } from "@mui/material";
import { useState } from "react";
import { ReactComponent as Eye } from "../../../../../assets/icons/eye.svg";
import { ReactComponent as EyeSlash } from "../../../../../assets/icons/eye-slash.svg";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import az from "date-fns/locale/az";
import moment from "moment";

export default function InputField({
  formik,
  modalData,
  inputName,
  updateModalState,
}) {
  const [shrink, setShrink] = useState(false);
  const [viewPass, setViewPass] = useState(true);
  registerLocale("az", az);

  const renderDatePicker = (dateName, label) => (
    <div className="render-datepicker">
      <label>
        {label}{" "}
        {(modalData.status === "sold" || dateName === "contactDate") && (
          <span style={{ color: "red" }}>*</span>
        )}
      </label>

      <DatePicker
        selected={modalData[dateName] ? new Date(modalData[dateName]) : null}
        onChange={(date) => updateModalState(dateName, date)}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        dateFormat="dd/MM/yyyy"
        placeholderText="dd/mm/yyyy"
        locale="az"
      />
    </div>
  );

  const inputData = [
    {
      inputName: "companyName",
      label: "Şirkətin adı",
      type: "text",
      inputValue: modalData?.companyName || "",
      required: true,
    },
    {
      inputName: "directorFullName",
      label: "Direktor adı, soyadı",
      type: "text",
      inputValue: modalData?.directorFullName || "",
      marginTop: "24px",
    },
    {
      inputName: "companyVoen",
      label: "Şirkət vöeni",
      type: "text",
      inputValue: modalData?.companyVoen || "",
      marginTop: "24px",
    },
    {
      inputName: "bankName",
      label: "Bankın adı",
      type: "text",
      inputValue: modalData?.bankName || "",
      required: true,
      marginTop: "24px",
    },
    {
      inputName: "correspondentAccount",
      label: "M/H",
      type: "text",
      inputValue: modalData?.correspondentAccount || "",
      required: true,
      marginTop: "24px",
    },
    {
      inputName: "bankVoen",
      label: "Bankın vöeni",
      type: "text",
      inputValue: modalData?.bankVoen || "",
      required: true,
      marginTop: "24px",
    },
    {
      inputName: "bankCode",
      label: "Bankın kodu",
      type: "text",
      inputValue: modalData?.bankCode || "",
      required: true,
      marginTop: "24px",
    },
    {
      inputName: "swift",
      label: "SWIFT",
      type: "text",
      inputValue: modalData?.swift || "",
      required: true,
      marginTop: "24px",
    },
    {
      inputName: "settlementAccount",
      label: "H/H",
      type: "text",
      inputValue: modalData?.settlementAccount || "",
      required: true,
      marginTop: "24px",
    },
    {
      inputName: "contractStartDate",
      label: "Müqavilə başlama tarixi",
      type: "date",
      marginTop: "24px",
      marginBottom: "0",
      inputValue:
        modalData[inputName] && inputName === "contractStartDate"
          ? moment(modalData[inputName]).format("YYYY-MM-DD")
          : "",
    },
    {
      inputName: "contractEndDate",
      label: "Müqavilə bitmə tarixi",
      type: "date",
      marginTop: "24px",
      marginBottom: "0",
      inputValue:
        modalData[inputName] && inputName === "contractEndDate"
          ? moment(modalData[inputName]).format("YYYY-MM-DD")
          : "",
    },
    {
      inputName: "paymentDate",
      label: "Ödəniş tarixi",
      type: "date",
      marginTop: "24px",
      marginBottom: "0",
      inputValue:
        modalData[inputName] && inputName === "paymentDate"
          ? moment(modalData[inputName]).format("YYYY-MM-DD")
          : "",
    },
    {
      inputName: "payment",
      label: "Ödəniş",
      type: "number",
      inputValue: modalData?.payment || "",
      required: false,
      marginTop: "24px",
    },
    {
      inputName: "contactDate",
      label: "İlkin zəng ediləcək",
      type: "date",
      className: "birthday-input",
      required: true,
      inputValue:
        modalData[inputName] && inputName === "contactDate"
          ? moment(modalData[inputName]).format("YYYY-MM-DD")
          : "",
      marginTop: "24px",
    },
    {
      inputName: "relatedPersonEmail",
      label: "Əlaqəli şəxsin maili",
      type: "email",
      className: "birthday-input",
      required: true,
      inputValue: modalData?.relatedPersonEmail || "",
      marginTop: "24px",
    },
    {
      inputName: "relatedPersonFullName",
      label: "Əlaqəli şəxsin adı və soyadı",
      type: "text",
      required: true,
      inputValue: modalData?.relatedPersonFullName || "",
      marginTop: "24px",
    },
    {
      inputName: "relatedPersonPosition",
      label: "Əlaqəli şəxsin vəzifəsi",
      type: "text",
      required: true,
      inputValue: modalData?.relatedPersonPosition || "",
      marginTop: "24px",
    },
    {
      inputName: "relatedPersonPosition",
      label: "Əlaqəli şəxsin vəzifəsi",
      type: "text",
      required: true,
      inputValue: modalData?.relatedPersonPosition || "",
      marginTop: "24px",
    },
    {
      inputName: "relatedPersonPhone",
      label: "Əlaqəli şəxsin telefon nömrəsi",
      type: "text",
      required: true,
      inputValue: modalData?.relatedPersonPhone || "",
      marginTop: "24px",
    },
    {
      inputName: "addInfo",
      label: "Statusa əlavə qeyd",
      type: "text",
      inputValue: modalData?.addInfo || "",
      marginTop: "24px",
    },
  ];

  return (
    <div
      className={
        inputData.find((item) => item.inputName === inputName)?.className || ""
      }
    >
      <TextField
        multiline={inputName === "addInfo"}
        minRows={inputName === "addInfo" ? 3 : undefined}
        maxRows={inputName === "addInfo" ? 10 : undefined}
        sx={{
          "& input": {
            fontSize: "12px",
            paddingRight: inputData.find((item) => item.inputName === inputName)
              ?.paddingRight,
          },
          marginTop: inputData.find((item) => item.inputName === inputName)
            ?.marginTop,
          marginBottom: inputData.find((item) => item.inputName === inputName)
            ?.marginBottom,
          "& .MuiInputLabel-root.Mui-required:after": {
            content: '" *"',
            color: "red",
            fontSize: "12px",
          },
        }}
        InputLabelProps={{
          shrink:
            inputData.find((item) => item.inputName === inputName)?.type ===
              "date" ||
            inputData.find((item) => item.inputName === inputName)?.type ===
              "time"
              ? true
              : inputData.find((item) => item.inputName === inputName)
                    ?.inputValue
                ? true
                : shrink,
          style: {
            fontSize: "12px",
            color: "#3F3F3F",
            marginBottom: inputData.find((item) => item.inputName === inputName)
              .marginBottom,
          },
        }}
        fullWidth
        id={inputName}
        name={inputName}
        type={inputData.find((item) => item.inputName === inputName).type}
        label={inputData.find((item) => item.inputName === inputName).label}
        value={
          inputData.find((item) => item.inputName === inputName)?.inputValue
        }
        onWheel={(e) => e.target.blur()}
        onChange={(e) => updateModalState(inputName, e.target.value)}
        onBlur={(e) => {
          formik.setFieldTouched(inputName, true);
          setShrink(!!e.target.value);
        }}
        onFocus={() => setShrink(true)}
        required={
          inputData.find((item) => item.inputName === inputName)?.required
        }
      />

      {formik.errors[inputName] && formik.touched[inputName] && (
        <small className="validation-err-message">
          {formik.errors[inputName]}
        </small>
      )}
    </div>
  );
}
